import { lazy } from 'react';

export const OrgManagementPage = lazy(() => import('./org-management-page'));
